import React, { useContext } from "react"
import { Card, CardBody, Col, Button } from "reactstrap"
import NotificationContext from './NotificationContext';

function Header() {
  const { loadNotificationConfig, loading } = useContext(NotificationContext)

  const handleRefresh = () => {
    loadNotificationConfig()
  }

  return (
    <Card>
      <CardBody>
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div className="float-start">
              <h5 className="text-primary">Notification Management</h5>
            </div>
            <div className="float-end">
              <Button color="outline-primary" size="sm" onClick={handleRefresh} disabled={loading} >
                <i className="fas fa-sync-alt me-1"></i>
                Refresh
              </Button>
            </div>
          </div>
        </Col>
      </CardBody>
    </Card>
  )
}

export default Header